
const initialOpportunitiesToDisplay = 10;
const incrementOpportunitiesBy = 10;

class OpportunitiesPanelController {
  constructor(
    $q,
    $scope,
    LogService,
    APIService
  ) {
    "ngInject";
    this.$q = $q;
    this.$scope = $scope;
    this.LogService = LogService;
    this.APIService = APIService;

    this._numOpportunitiesToDisplay = initialOpportunitiesToDisplay;
  }

  set staffUser(staffUser) {
    this._staffUser = staffUser;
  }

  get staffUser() {
    return this._staffUser;
  }

  set opportunities(opportunities) {
    this._opportunities = opportunities;
  }

  get opportunities() {
    return this._opportunities;
  }

  get isOnline() {
    return this.APIService && this.APIService.isOnline;
  }

  get numOpportunitiesToDisplay() {
    return this._numOpportunitiesToDisplay;
  }

  get showLoadMoreButton() {
    return this.opportunities && this.numOpportunitiesToDisplay < this.opportunities.length;
  }

  set initiallyOpen(open) {
    this._initiallyOpen = open;
  }

  get initiallyOpen() {
    return this._initiallyOpen;
  }

  incrementNumOpportunitiesToDisplay() {
    this._numOpportunitiesToDisplay += incrementOpportunitiesBy;
  }

  toggleCollapsed() {
    if (this.onToggleCollapsed) {
      this.onToggleCollapsed();
    } else {
      this.LogService && this.LogService.warn(`OpportunitiesPanelController.toggleCollapsed no callback found`);
    }
  }
}

export default OpportunitiesPanelController;

